(function () {
  'use strict';

  d3.chart('ChartBase').extend('SizeAdviceChart', {
    initialize: function (options) {
      var plot = this;
      options = options || {};

      _.defaultsDeep(options, {
        horizontal: true,
        barSpacing: 0,
        dashedLabelBoxes: false,
        zebraLabels: false,
        barThickness: 10
      });

      var thickness = 'height';
      var length = 'width';
      var sizeAdviceColor = '#7C0A40';
      var plotLineBarColor = '#DBDBDB';
      var sizeAdviseWidth = 7;
      var sizeAdviseThickness = 15;
      var yBarOffset = 5;
      var yMarkerCoordinate = -3;
      var markerAdjustment = -3;

      plot.layers = {
        plotLine: plot.wrap.append('g').classed('plotLine', true)
      };

      plot.bucket = d3.scale.ordinal();
      plot.value = d3.scale.linear();


      // We wrap the original datum in an array with its rank.
      // This augments the given function to just get the datum
      function origDatum(fn) {
        return function (datumRankPair, i, j, k) {
          return fn.call(this, datumRankPair[0], i, j, k);
        };
      }

      function byBucket(item, index) {
        return plot.bucket(index);
      }

      plot.layer('plotLine', plot.layers.plotLine, {
        dataBind: function (data) {
          return this.selectAll('.bucket')
              .data(data.page);
        },
        insert: function () {
          var group = this.append('g').classed('bucket', true);
          group.append('rect').classed('bar', true);
          return group;
        },
        events: {
          exit: function () {
            this.remove();
          },
          merge: function () {
            var bucket = this;

            bucket.translate(origDatum(function (item) {
              var bucketPos = byBucket.apply(this, arguments) + yBarOffset;
              return [0, bucketPos];
            }));


            var barBg = bucket.select('.bar')
                .classed('even', true)
                .attr(thickness, options.barThickness)
                .attr(length, plot.w)
                .style('fill', plotLineBarColor);

            var group = bucket.selectAll('.bar-grp')
                .data(plot.markers);

            group.exit().remove();

            var newGroups = group.enter()
                .append('g').classed('bar-grp', true);

            newGroups.append('rect')
                .classed('marker', true);

            group.select('.marker')
                .attr(thickness, sizeAdviseThickness)
                .attr(length, sizeAdviseWidth / 2)
                .attr('fill', plotLineBarColor)
                .translate(function (item, index) {
                  return [plot.value(index) === 0 ? 0 : (plot.value(index) + markerAdjustment), yMarkerCoordinate];
                });

            newGroups.append('rect')
                .classed('sizeAdvice', true);

            group.select('.sizeAdvice')
                .attr(thickness, sizeAdviseThickness)
                .attr(length, sizeAdviseWidth)
                .attr('fill', sizeAdviceColor)
                .translate(function (d, i, j) {
                  var markerIndex = plot.data.page[j][0].sizeAdvice + 2;
                  return [plot.value(markerIndex) === 0 ? 0 : plot.value(markerIndex) + 2 * markerAdjustment, yMarkerCoordinate];
                });
          }
        }
      });

      function calcRange() {
        var spacing = options.barSpacing;

        plot.bucket.rangeRoundBands([0, plot.h], spacing, 0);
        // Draw labels so we can accurately calculate their maximum size.
        // This needs to be done AFTER setting the bucket.range to avoid an exception.
        plot.layer('plotLine').translate(0, 0);

        plot.value.range([0, Math.max((plot.w), 0)]);
      }

      plot.on('change:width', calcRange)
          .on('change:height', calcRange)
          .on('change:data', calcRange);
    },

    valuesArray: function (item) {
      return this.fn.value.map(function (fn) {
        return fn(item);
      });
    },
    transform: function (data) {
      var plot = this;

      if (data !== plot.data) {
        _.defaults(data, {
          fn: {}
        });
        plot.fn = _.defaults(data.fn, {
          value: _.property('sizeAdvice'),
          color: ["#ABABAB"]
        });

        if (!_.isArray(plot.fn.value)) {
          plot.fn.value = [plot.fn.value];
        }
        if (!_.isArray(plot.fn.color)) {
          plot.fn.color = [plot.fn.color];
        }

        // developer errors
        if (plot.fn.value.length > 1) {
          if (!_.isArray(plot.fn.stackLabel) || plot.fn.stackLabel.length !== plot.fn.value.length) {
            throw new Error('plot.fn.value has more than 1 function yet plot.fn.stackLabel is not an array of the same length');
          }
        }

        plot.value.domain([0, 4]);

        // setup a lazily evaluated chain of transformations
        var dataChain = _(data.data);

        // Hold onto the original ranking number, or else it'd be erased when filtering or paging
        dataChain = dataChain.map(function (d, i) {
          return [d, i + 1];
        });

        // Finally evaluate the chain of transformations above to a concrete values
        data.data = dataChain.value();
        data.page = data.data;
        plot.bucket.domain(d3.range(data.page.length));

        plot.data = data;
        plot.markers = [-2, -1, 0, 1, 2];
      }

      return data;
    }
  })
})();